import { render } from "./faFact.vue?vue&type=template&id=6908776a"
import script from "./faFact.vue?vue&type=script&lang=js"
export * from "./faFact.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__